import React from "react";
import PropTypes from "prop-types";

import StoresRegionSelect from "@components/Stores/StoresRegionSelect";
import StoreCards from "@components/Stores/StoreCards";

const StoresContainer = ({ stores, regions, currentRegion }) => (
  <>
    <StoresRegionSelect regions={regions} currentRegion={currentRegion} />
    <StoreCards stores={stores} />
  </>
);

StoresContainer.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      address: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      phoneNumber: PropTypes.string,
      schedule: PropTypes.array,
    })
  ),
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url_key: PropTypes.string.isRequired,
    })
  ),
};

export default StoresContainer;
